var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagActiveWithoutCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    transform: "translate(-971 -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    transform: "translate(971 407)",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "none",
    stroke: "#A3D7EE",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    transform: "translate(8.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    fill: "none",
    stroke: "#FF5939",
    strokeLinecap: "round",
    x1: 971.5,
    y1: 414,
    x2: 971.5,
    y2: 424
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    fill: "#FF5939",
    d: "M971.5,414h7.979l-2.006,2.553l2.006,2.414H971.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    fill: "none",
    stroke: "#FF5939",
    strokeLinecap: "round",
    x1: 970.5,
    y1: 424.5,
    x2: 972.5,
    y2: 424.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagActiveWithoutCircle);
export default __webpack_public_path__ + "static/media/flag_active-without-circle.562b1013b07667a1abb1bfe6ec958ea0.svg";
export { ForwardRef as ReactComponent };